import { render, staticRenderFns } from "./DocumentToc.vue?vue&type=template&id=6b370b96&"
import script from "./DocumentToc.vue?vue&type=script&lang=js&"
export * from "./DocumentToc.vue?vue&type=script&lang=js&"
import style0 from "./DocumentToc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports